import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { Account, GeoLocationForApi } from '@pp/core/entities';

import { InviteTokenStatus } from '../auth.entities';
import {
  AuthorizationReq,
  AuthorizationRes,
  ChangeEmailPhoneReq,
  PasswordRecoveryReq,
  SetDataReq,
  SetPhoneReq,
  SetTfaRes,
  SuccessRes,
  UserAcceptInviteReq,
  VerifyEmailPhoneReq,
} from '../model';

export interface AuthApi {
  signUp(data: UserAcceptInviteReq): Observable<AuthorizationRes>;
  checkInviteToken(token: string): Observable<InviteTokenStatus>;
  whoAmI(): Observable<Account>;
  signIn(data: Pick<AuthorizationReq, 'login' | 'password' | 'code'>): Observable<AuthorizationRes>;
  setPhone(phone: SetPhoneReq): Observable<SuccessRes>;
  changePhone(req: SetPhoneReq): Observable<SuccessRes>;
  setData(data: SetDataReq): Observable<SuccessRes>;
  verifyEmail(code: string): Observable<SuccessRes>;
  resendEmailVerificationCode(): Observable<SuccessRes>;
  verifyPhone(code: string): Observable<SuccessRes>;
  setTfa(): Observable<SetTfaRes>;
  resendPhone(): Observable<SuccessRes>;
  recoveryEmail(email: string): Observable<SuccessRes>;
  recoveryPassword(payload: PasswordRecoveryReq): Observable<SuccessRes>;
  activateTfa(code: string): Observable<SuccessRes>;
  changeEmailPhone(req: ChangeEmailPhoneReq): Observable<SuccessRes>;
  verifyEmailPhone(req: VerifyEmailPhoneReq): Observable<SuccessRes>;
  setAddress(address: GeoLocationForApi): Observable<SuccessRes>;
}

export const AUTH_API = new InjectionToken<AuthApi>('AUTH_API');
